import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {withTranslation} from 'react-i18next';
import { DialogModal } from './common/DialogModal';
import {
  removeUnofficialResult
} from '../../data/UnofficialResultsStream';
import {DateTime} from '../shared/DateTime';
import {fetchAthleteRaces} from '../../data/AthleteStreams';

class UnofficialRemoveComponent extends Component {
  static propTypes = {
    t: PropTypes.func
  };

  state = {
    success: true
  };

  getBody(){

    const {
      raceName,
      raceDate
    } = this.props;

    const raceNameStyle = {
        color: '#4a4a4a',
        paddingBottom: 4,
        fontSize: 22,
        lineHeight: '1em',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    };

    const dateStyle = {
      display: 'inline-block',
      flex: '0 0 auto',
      verticalAlign: 'top',
      paddingRight: 20,
      marginRight: 20,
      fontFamily: 'ProximaNovaRegular, helvetica, arial, sans-serif',
      color: '#4a4a4a',
      fontSize: 14,
      lineHeight: '20px'
    };

    const mainStyle = {
      padding: 20,
      borderBottom: '1px solid #dddddd',
      borderTop: '1px solid #dddddd'
    };

    return (
      <div style={mainStyle}>
        <div style={raceNameStyle}>{raceName}</div>
        <div style={dateStyle}>
          <DateTime
            date={raceDate}
            showTime={false}
            icon={null}
          />
        </div>
      </div>
    );
  }

  removeFromUnofficialResults = async () => {
    const removeUnofficialResultStream = await removeUnofficialResult(this.props.eventCourseId);
    return removeUnofficialResultStream.subscribe(() => {
      this.props.handleClose();
      fetchAthleteRaces(this.props.athleteId, true);
    });
  };

  getActions() {
    const {
      t
    } = this.props;

    const closeCallback = this.props.handleClose;
    const modalButton = {
      minWidth: 100,
      height: 50,
      color: '#fff',
      backgroundColor: '#16A9E1',
      border: '2px solid #16A9E1',
      fontSize: 25,
      textTransform: 'capitalize',
      fontFamily: 'ProximaNovaRegular',
      paddingLeft: 50,
      paddingRight: 50
    } ;
    const closeButton = {
      color: '#4a4a4a'
    };
    const actionButtonContainer = {
      textAlign: 'right',
      borderTop: 'none',
      textTransform: 'capitalize',
    };

    return (
      <div style={actionButtonContainer}>
        <div>
          {/*<FlatButton*/}
          {/*  backgroundColor='#fff'*/}
          {/*  hoverColor='#fff'*/}
          {/*  label={t('Cancel')}*/}
          {/*  style={closeButton}*/}
          {/*  primary={true}*/}
          {/*  onTouchTap={closeCallback}*/}
          {/*/>*/}
          {/*<FlatButton*/}
          {/*  backgroundColor='#009fb7'*/}
          {/*  hoverColor='#00B5D0'*/}
          {/*  label={t('Remove')}*/}
          {/*  style={modalButton}*/}
          {/*  primary={true}*/}
          {/*  onTouchTap={this.removeFromUnofficialResults.bind(this)}/>*/}
        </div>
      </div>
    );
  }

  render() {
    const {
      t
    } = this.props;

    const modalH1 = {    fontSize: 25,
      float: 'left',
      width: '100%',
      marginBottom: 20,
      fontFamily: 'ProximaNovaRegular'  };
    const actionStyle = {
      paddingRight: 40,
      borderTop: 'none',
      paddingBottom: 40,
      marginTop: 20
    };
    return (
      <div>
        <DialogModal
          isMobile={this.props.isMobile}
          title={<span style={modalH1}>{
            t('Are you sure you want to remove this result from your profile?')
          }</span>}
          body={this.getBody()}
          actions={this.getActions()}
          actionsContainerStyle={actionStyle}
          open={this.props.open}
          onRequestClose={this.props.handleClose}
          bodyStyle={{minHeight: 120}}/>
      </div>
    );
  }
}

export const UnofficialRemove = withTranslation()(UnofficialRemoveComponent);



/** WEBPACK FOOTER **
 ** ./components/modal/UnofficialRemove.js
 **/